import React, { useContext, useCallback } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { NonAuthRoutes, RouteParamsTypes, Modules, AuthRoutes } from '../enums';
import { AuthContext } from '../contexts/AuthContext';
import PublicLayout from '../components/Layout/Public';
import Login from '../modules/auth/login';
import ForgotPassword from '../modules/auth/forgotPassword';
import ResetPassword from '../modules/auth/resetPassword';

const Auth: React.FC = () => {
  const {
    token
  } = useContext(AuthContext);

  const handleBlankRoute = useCallback(() => {
    if (token) {
      return Modules.home + AuthRoutes.dashboard;
    } else {
      return Modules.auth + NonAuthRoutes.login;
    }
  }, [token]);

  return (
    <Routes>
      <Route path={NonAuthRoutes.login} element={<PublicLayout route={NonAuthRoutes.login} children={<Login />} />} />
      <Route path={NonAuthRoutes.forgotPassword} element={<PublicLayout route={NonAuthRoutes.forgotPassword} children={<ForgotPassword />} />} />
      <Route path={NonAuthRoutes.resetPassword} element={<PublicLayout route={NonAuthRoutes.resetPassword} children={<ResetPassword />} />} />
      <Route path={RouteParamsTypes.blank} element={<Navigate replace to={{ pathname: handleBlankRoute() }} />} />
      <Route path={RouteParamsTypes.any} element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />} />
    </Routes>
  );
};

export default Auth;
